// Features/TablecontentDraw/mod.ts
class TableOfContentsDrawer extends HTMLElement {
  constructor() {
    super();
    this.toolbarElement = this.querySelector('.shortcodetoolbar');
    this.popoverElement = document.getElementById('tableofcontents-popup');
    this.button = this.toolbarElement.querySelector('.shortcodetoolbar__item');
    this.closeBtn = this.popoverElement.querySelector('[data-action="close-popup"]');
    this.pageOverlay = document.querySelector('.pageoverlay');
  }

  connectedCallback() {
    const isVisible = this.popoverElement.getAttribute('aria-hidden') === 'false';
    this.button.setAttribute('aria-expanded', isVisible);
    this.button.addEventListener('click', () => {
      const isVisible = this.popoverElement.getAttribute('aria-hidden') === 'false';
      this.popoverElement.setAttribute('aria-hidden', isVisible);
      this.button.setAttribute('aria-expanded', isVisible);
      if (this.pageOverlay) {
        this.pageOverlay.classList.toggle('is-visible', !isVisible);
      }
    });

    this.closeBtn.addEventListener('click', () => {
      this.popoverElement.setAttribute('aria-hidden', 'true');
      this.button.setAttribute('aria-expanded', 'false');
      if (this.pageOverlay) {
        this.pageOverlay.classList.remove('is-visible');
      }
    });
  }
}
customElements.define('tableofcontents-drawer', TableOfContentsDrawer);
